import Icon from '@/components/ui/AppIcon';

interface OnboardingStep {
  step: number;
  title: string;
  description: string;
  icon: string;
}

const OnboardingPreview = () => {
  const steps: OnboardingStep[] = [
    {
      step: 1,
      title: "Download & Install",
      description: "Get Signaly from App Store or Google Play in seconds",
      icon: "ArrowDownTrayIcon"
    },
    {
      step: 2,
      title: "Create Your Account",
      description: "Sign up with email or social login for instant access",
      icon: "UserPlusIcon"
    },
    {
      step: 3,
      title: "Choose Your Markets",
      description: "Select crypto, forex, or both based on your interests",
      icon: "ChartBarIcon"
    },
    {
      step: 4,
      title: "Start Paper Trading",
      description: "Practice with virtual money to build confidence",
      icon: "AcademicCapIcon"
    },
    {
      step: 5,
      title: "Go Live & Profit",
      description: "Upgrade to premium and start following real signals",
      icon: "RocketLaunchIcon"
    }
  ];

  return (
    <section className="py-20 px-4 lg:px-8 bg-card">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground mb-4">
            Get Started in 5 Simple Steps
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From download to your first profitable trade in minutes, not hours
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-primary via-secondary to-accent transform -translate-y-1/2"></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-background border border-border rounded-2xl p-6 hover:shadow-cyan-glow transition-all duration-200 h-full">
                  <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-full mb-4 mx-auto">
                    <Icon name={step.icon as any} size={28} className="text-white" />
                  </div>
                  <div className="absolute top-4 right-4 flex items-center justify-center w-8 h-8 bg-primary text-primary-foreground rounded-full text-sm font-heading font-bold">
                    {step.step}
                  </div>
                  <h3 className="text-xl font-heading font-bold text-foreground mb-3 text-center">{step.title}</h3>
                  <p className="text-sm text-muted-foreground text-center">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-2 px-6 py-3 bg-success/10 border border-success/20 rounded-full">
            <Icon name="ClockIcon" size={20} className="text-success" />
            <span className="text-sm font-medium text-success">Average setup time: Less than 5 minutes</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnboardingPreview;